/**
 * C14 draft-browse grant. The Admin host mints a grant for ITS OWN store and
 * hands it to the verified canvas. The canvas sends it as this header on its
 * catalog reads only, so the merchant's real catalog renders in the draft
 * storefront even while the store is not public.
 *
 * The grant opens the store-visibility gate of catalog reads and nothing
 * else: no write, no other store, no product that is unpublished itself and
 * no website configuration.
 */
export const WEBSITE_DRAFT_BROWSE_HEADER = 'x-dukanti-draft-browse';

/** 32 random bytes as lowercase hex. The server stores its SHA-256 only. */
export const WEBSITE_DRAFT_BROWSE_TOKEN_RE = /^[a-f0-9]{64}$/;

/** The server never issues a longer grant. */
export const WEBSITE_DRAFT_BROWSE_TTL_MS = 30 * 60_000;

export function isWebsiteDraftBrowseToken(value: unknown): value is string {
  return typeof value === 'string' && WEBSITE_DRAFT_BROWSE_TOKEN_RE.test(value);
}
